import Main from "./Layout/Main";
import Navbar from "./Layout/Navbar";
import Dashboard from "./Layout/Dashboard";

export default Object.assign({}, { Main, Navbar, Dashboard });
